import { useState, useEffect } from 'react';
import ExchangeMoneyService from './ExchangeMoneyService';

const useExchangeMoney = () => {
  const [moneys, setMoneys] = useState([])
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  const saveExchangeMoney = async (formData) => {
    console.log(formData)
    let result = true
    setIsLoading(true);
    try {
        await ExchangeMoneyService.saveExchangeMoney(formData);
        await getExchangeMoneys()
        result = true
    } catch (err) {
        console.log(err.response.data.message || 'An error occurred.');
        result = err.response.data.message
    } finally {
      setIsLoading(false);
    }
    return result
  };

  const getExchangeMoneys = async () => {
    setIsLoading(true);
    try {
      const response = await ExchangeMoneyService.getExchangeMoneys();
      setMoneys(response.data);
      setError(null);
    } catch (err) {
        setError(err);
        console.log(err)
    } finally {
        setIsLoading(false);
    }
  };


  return { 
    moneys,
    saveExchangeMoney,
    getExchangeMoneys
  };
}

export default useExchangeMoney;
